import React from 'react';
import { Typography } from '@mui/material';
import DraggableWidget from '../../../CustomDashboards/components/DraggableWidget';
import renderWidget from '../../../CustomDashboards/components/Widgets/RenderWidget';
import {
  PieBasicLegendPosition,
  PieCategoryWidgetTypes,
  PieLegendStyles,
  PieSubType,
  WidgetCategory,
} from '../../../CustomDashboards/types';
import { getIncidentStatus } from '../queries';
import { FilterContext, SelectedWidgetData, TableDataType } from '../types';

const INCIDENT_CURRENT_STATUS_NAME = 'incident.current_status.name';

interface IncidentStatusProps {
  filterContext: FilterContext;
  selected?: SelectedWidgetData;
  closeInteractive?: () => void;
  onSelect?: (selected: SelectedWidgetData) => void;
}
const getIncidentByStatusWidget = ({ filterContext }: { filterContext: FilterContext }): PieCategoryWidgetTypes => ({
  id: '',
  definition: {
    title: {
      title: 'Incident Status',
    },
    coords: {
      x: 0,
      y: 0,
      h: 3,
      w: 0,
    },
    custom: {
      showTotals: true,
      legend: {
        position: PieBasicLegendPosition.Top,
        style: PieLegendStyles.Table,
        showValues: true,
      },
      fieldsPalette: {},
    },
  },
  category: WidgetCategory.Pie,
  type: PieSubType.Donut,
  requests: [getIncidentStatus(filterContext)],
});

const IncidentStatus = (props: IncidentStatusProps) => {
  const { selected, closeInteractive, filterContext, onSelect } = props;

  const incidentByStatusWidget = React.useMemo(() => getIncidentByStatusWidget({ filterContext }), [filterContext]);

  React.useEffect(() => {
    if (!selected && closeInteractive) {
      closeInteractive();
    }
  }, [selected, closeInteractive]);

  const onHandleSelect = selectionArray => {
    const lastSelectedItem = selectionArray.length > 0 ? selectionArray.at(-1) : null;

    if (lastSelectedItem) {
      const newSelectedData: SelectedWidgetData = {
        value: [{ value: lastSelectedItem.originalValue, index: lastSelectedItem.index }],
        name: lastSelectedItem.originalValue,
        filter: { [INCIDENT_CURRENT_STATUS_NAME]: [lastSelectedItem.originalValue] },
        tableType: TableDataType.INCIDENT,
      };

      if (onSelect) {
        onSelect(newSelectedData);
      }
    } else {
      onSelect?.(null as any); // Clear selection in parent
    }
  };

  return (
    <DraggableWidget
      sx={{ border: 'none' }}
      widget={incidentByStatusWidget}
      clickInteractions={
        onSelect
          ? [
              {
                title: 'View Items',
                icon: null,
                isEnabledForCell: () => true,
                onClick: v => onHandleSelect([v.d]),
              },
            ]
          : []
      }
      customToolbar={
        <Typography sx={{ whiteSpace: 'nowrap', fontSize: '18px', mb: '8px' }} variant="h2">
          Incident Status
        </Typography>
      }
      onSelect={onHandleSelect}
      selected={selected?.value}>
      {renderWidget({
        widget: incidentByStatusWidget,
      })}
    </DraggableWidget>
  );
};

export default IncidentStatus;
